import { Controller } from "react-hook-form";
import classNames from "classnames";
import { NoteFlagIcon } from "@/shared/icons";
import { AppButton } from "@/shared/Components";
import styles from "./styles.module.scss";

export const ImportantFlag = () => {
  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <AppButton className={styles.button} onClick={() => onChange(!value)}>
          <NoteFlagIcon
            className={classNames(styles.flag, {
              [styles.active]: value,
            })}
          />
        </AppButton>
      )}
      name={"currentNote.important"}
    />
  );
};
